import React, { Component } from 'react';
import OrderItem from './orderItem.jsx';
import './orderbook.css'

class Orders extends Component {
  renderItems(offers){
    return offers.map(({amount,price,id,cml,isBlank,orders}, i) => {
      return (<OrderItem key={i} orders={orders} amount={amount} price={price} type={this.props.orderType} id={`${amount}${price}${Math.random()*100}`} cml={cml} isBlank={isBlank} />)
    });
  }
  renderWait(){
    return new Array(20).fill(<tr>{new Array(4).fill(<td>-</td>)}</tr>)
  }
  render() {
    let items = this.props.orders && this.props.orders.length > 0 ? this.renderItems(this.props.orders) : this.renderWait();
    return (
      <table className={"white-text order-book"} style={{tableLayout:"fixed",fontSize:"0.9em"}}>
        <tbody>
          {items}
        </tbody>
      </table>
    )
  }
}

export default Orders;
